export default "__VITE_ASSET__Dww4QKWX__"